import { defineMessages } from 'react-intl';

export default defineMessages({
  findMenuItem: {
    id: 'app.common.sidebar.findMenuItem',
    defaultMessage: 'Find menu item',
  },
  menuItemNotFound: {
    id: 'app.common.sidebar.menuItemNotFound',
    defaultMessage: 'Menu item not found',
  },
});
